<template>
    <template v-if="!isFileExpired && isMediaSuported">
        <img
            v-if="isImage"
            class="vx-h-auto vx-rounded-2xl vx-max-w-[200px] vx-max-h-[600px]"
            :src="props.mediaUrl"
            :alt="`message_image`"
            @error="onObjectError"
        />
        <video v-else-if="isVideo" controls class="w-9/12 w-9/12 vx-rounded-s">
            <source :src="props.mediaUrl" :type="props.mediaContentType" @error="onObjectError" />
        </video>
        <audio v-else-if="isAudio" controls>
            <source :src="props.mediaUrl" :type="props.mediaContentType" @error="onObjectError" />
        </audio>
        <div v-else-if="isPdf" class="vx-flex vx-flex-col vx-gap-0.5 vx-items-center vx-justify-between">
            <div>
                <font-awesome-icon v-if="isUseStabIcon" :icon="faFile" size="10x" />
                <font-awesome-icon v-else :icon="faFilePdf" class="vx-text-gray-600" size="5x" />
            </div>
            <a :href="props.mediaUrl" target="_blank" rel="noopener noreferrer">View</a>
        </div>
        <div v-else-if="isVCard" class="vx-flex vx-flex-col vx-items-center vx-justify-between">
            <div class="">
                <font-awesome-icon v-if="isUseStabIcon" :icon="faFile" size="10x" />
                <font-awesome-icon v-else :icon="faCreditCardFront" class="vx-text-gray-600" size="5x" />
            </div>
            <a :href="props.mediaUrl" target="_blank" rel="noopener noreferrer">View</a>
        </div>
        <media-placeholder
            v-else
            class="vx-text-slate-900"
            @click.stop="emit('mediaPlaceholderClick', { isFileExpired: isFileExpired })"
        >
            <a :href="props.mediaUrl" download target="_blank" rel="noopener noreferrer">Download</a>
        </media-placeholder>
    </template>
    <template v-else>
        <media-placeholder
            class="vx-text-slate-900"
            @click.stop="emit('mediaPlaceholderClick', { isFileExpired: isFileExpired })"
        >
            <template v-if="isFileExpired">Media Expired</template>
            <template v-else>
                <a :href="props.mediaUrl" download target="_blank" rel="noopener noreferrer">Download</a>
            </template>
        </media-placeholder>
    </template>
</template>

<script setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import MediaPlaceholder from './MediaPlaceholder.vue';
import { ref } from 'vue';
import { faFile, faFilePdf } from '@fortawesome/pro-regular-svg-icons';
import { faCreditCardFront } from '@fortawesome/pro-solid-svg-icons';
import { computed } from 'vue';

const props = defineProps({
    mediaUrl: {
        type: String,
        requried: true,
    },
    mediaContentType: {
        type: String,
        requried: true,
    },
    isUseStabIcon: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['mediaPlaceholderClick']);

const isImage = computed(() =>
    Boolean(
        props.mediaUrl?.toLowerCase()?.match(/\.(png|jpg|jpeg|gif|bmp)$/) ||
            (props.mediaContentType || '').toLowerCase().includes('image')
    )
);
const isVideo = computed(() =>
    Boolean(
        props.mediaUrl?.toLowerCase().match(/\.(mp4|webm)$/) ||
            (props.mediaContentType || '').toLowerCase().includes('video')
    )
);
const isAudio = computed(() =>
    Boolean(
        props.mediaUrl?.toLowerCase().match(/\.(mp3|mpeg|ogg|wav)$/) ||
            (props.mediaContentType || '').toLowerCase().includes('audio')
    )
);
const isPdf = computed(() =>
    Boolean(
        props.mediaUrl?.toLowerCase().match(/\.(pdf)$/) || (props.mediaContentType || '').toLowerCase().includes('pdf')
    )
);
const isVCard = computed(() =>
    Boolean(
        props.mediaUrl?.toLowerCase().match(/\.(vcf|vcard)$/) ||
            (props.mediaContentType || '').toLowerCase().includes('vcard')
    )
);

const isMediaSuported = ref(true);
const isFileExpired = ref(false);

const onObjectError = async () => {
    if (!props.mediaUrl) {
        return;
    }

    try {
        const res = await fetch(props.mediaUrl);
        if (res.ok) {
            isMediaSuported.value = false;
        } else {
            isFileExpired.value = true;
        }
    } catch (error) {
        console.error(error);
    }
};
</script>
